import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      {/* 必要に応じてフッターの内容を追加 */}
    </footer>
  );
};

export default Footer;
